import { Joi, objectSchemaOf } from '../helpers';

export const sendMessageAsHilParamsSchema = objectSchemaOf<
  ISendMessageAsHilParams
>({
  message: Joi.string().required(),
  messageId: Joi.string(), // non-breaking, will need to be made mandatory
  conversationId: Joi.string().required(),
});

export interface ISendMessageAsHilParams {
  message: string;
  messageId?: string; // non-breaking, will need to be made mandatory
  conversationId: string;
}
